import { useMemo, useState, useCallback } from 'react';
import { DEFAULT_DEV_OPTIONS } from '../types/devOptions.js';

const useDevOptions = () => {
    const isDevMode = useMemo(() => new URLSearchParams(window.location.search).get('isDev') === 'true', []);
    const [devOptionsExpanded, setDevOptionsExpanded] = useState(false);
    const [useTextRecall, setUseTextRecall] = useState(DEFAULT_DEV_OPTIONS.useTextRecall);
    const [pageSize, setPageSize] = useState(DEFAULT_DEV_OPTIONS.pageSize);
    const [rankingWeights, setRankingWeights] = useState(Object.assign({}, DEFAULT_DEV_OPTIONS.rankingWeights));
    const handleWeightChange = useCallback((key, newValue) => {
        setRankingWeights((prev) => {
            const otherKeys = Object.keys(prev).filter((k) => k !== key);
            const otherSum = otherKeys.reduce((sum, k) => sum + prev[k], 0);
            const remaining = Math.max(0, 1 - newValue);
            const updated = Object.assign(Object.assign({}, prev), { [key]: newValue });
            otherKeys.forEach((k) => {
                updated[k] = otherSum > 0 ? (prev[k] / otherSum) * remaining : remaining / otherKeys.length;
            });
            return updated;
        });
    }, []);
    const devOptions = useMemo(() => (isDevMode ? { useTextRecall, pageSize, rankingWeights } : undefined), [isDevMode, useTextRecall, pageSize, rankingWeights]);
    return {
        isDevMode,
        devOptionsExpanded,
        setDevOptionsExpanded,
        useTextRecall,
        setUseTextRecall,
        pageSize,
        setPageSize,
        rankingWeights,
        setRankingWeights,
        handleWeightChange,
        devOptions,
    };
};

export { useDevOptions };
//# sourceMappingURL=useDevOptions.js.map
